import React from 'react';
import { useDescriptionTemplateStore } from '../../../stores/descriptionTemplateStore';

interface DescriptionTemplateSelectorProps {
  selectedTemplateId: string | null;
  onChange: (templateId: string | null) => void;
}

export function DescriptionTemplateSelector({ 
  selectedTemplateId, 
  onChange 
}: DescriptionTemplateSelectorProps) {
  const { templates } = useDescriptionTemplateStore();

  return (
    <div className="space-y-2">
      <select
        value={selectedTemplateId || ''}
        onChange={(e) => onChange(e.target.value || null)}
        className="w-full rounded-md border-gray-300 text-sm"
      >
        <option value="">テンプレートを選択...</option>
        {templates.map(template => (
          <option key={template.id} value={template.id}>
            {template.name}
          </option>
        ))}
      </select>
      
      {selectedTemplateId && (
        <button
          onClick={() => onChange(null)}
          className="w-full text-xs text-red-600 hover:text-red-700 text-left"
        >
          テンプレートを解除
        </button>
      )}
    </div>
  );
}